import { useCallback, useEffect, useState } from 'react'
import { disableWebPushNotifications, enableWebPushNotifications, getWebPushPermission, isWebPushEnabledLocally, isWebPushSupportedInBrowser } from '../services/firebaseMessaging'

export function useWebPush() {
  const [supported, setSupported] = useState(false)
  const [permission, setPermission] = useState(() => getWebPushPermission())
  const [enabled, setEnabled] = useState(() => isWebPushEnabledLocally())
  const [busy, setBusy] = useState(false)

  const refresh = useCallback(async () => {
    const nextSupported = await isWebPushSupportedInBrowser()
    setSupported(nextSupported)
    setPermission(getWebPushPermission())
    setEnabled(isWebPushEnabledLocally())
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  const enable = useCallback(async () => {
    setBusy(true)
    try {
      const result = await enableWebPushNotifications({ forceRegister: true })
      await refresh()
      return result
    } finally {
      setBusy(false)
    }
  }, [refresh])

  const disable = useCallback(async () => {
    setBusy(true)
    try {
      await disableWebPushNotifications()
      await refresh()
      return { ok: true }
    } finally {
      setBusy(false)
    }
  }, [refresh])

  const toggle = useCallback(
    async (nextOn) => {
      if (nextOn) return enable()
      return disable()
    },
    [enable, disable],
  )

  return { supported, permission, enabled, busy, refresh, enable, disable, toggle }
}
